var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.143,
    height: 13.716,
    viewBox: "0 0 17.143 13.716",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-glass-cheers",
    "data-name": "Icon awesome-glass-cheers",
    d: "M17.125,11.611a1.068,1.068,0,0,0-1.4-.579l-.592.246L14.1,8.55a3.136,3.136,0,0,0,.924-4.093L12.7.426A.86.86,0,0,0,11.631.062L8.57,1.331,5.509.062A.857.857,0,0,0,4.437.426L2.118,4.457a3.135,3.135,0,0,0,.924,4.09L2.005,11.276l-.592-.246a1.069,1.069,0,0,0-1.4.579.215.215,0,0,0,.115.281l4.347,1.805a.212.212,0,0,0,.279-.115,1.074,1.074,0,0,0-.579-1.4l-.592-.246L4.641,9.158a3.175,3.175,0,0,0,.351.035A3.116,3.116,0,0,0,8.029,6.908l.541-2.02.541,2.02a3.116,3.116,0,0,0,3.037,2.285,3.175,3.175,0,0,0,.351-.035l1.053,2.775-.592.246a1.072,1.072,0,0,0-.579,1.4.213.213,0,0,0,.279.115l4.35-1.805A.214.214,0,0,0,17.125,11.611ZM7.389,4.339l-3-1.245.978-1.7L7.9,2.446Zm2.362,0L9.245,2.446,11.776,1.4l.978,1.7-3,1.245Z",
    transform: "translate(0.002 0.004)",
    fill: "#cea95a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass);
export default __webpack_public_path__ + "static/media/glass.27b3d4e0a2a95ad04647efb530bcd87c.svg";
export { ForwardRef as ReactComponent };